import React, { useState, useEffect } from 'react';
import { supabase } from '../utils/supabase';

// All contacts in the campaign
const ALL_CONTACTS = [
  { id: 'londonvp', email: 'hello@londonvp.com', campaign: 'A' },
  { id: 'bitkraft-pitch', email: 'pitch@bitkraft.vc', campaign: 'B' },
  { id: 'hiro-ian', email: 'ian@hiro.capital', campaign: 'B' },
  { id: 'hiro-samuel', email: 'samuel@hiro.capital', campaign: 'B' },
  { id: 'hiro-cherry', email: 'cherry@hiro.capital', campaign: 'B' },
  { id: 'playventures-henric', email: 'henric@playventures.vc', campaign: 'B' },
  { id: 'joystick-ivan', email: 'ivan@joystickventures.com', campaign: 'B' },
  { id: '1upfund-ed', email: 'ed@1upfund.com', campaign: 'B' },
  { id: 'transcend-andrew', email: 'andrew@transcend.fund', campaign: 'C' },
  { id: 'behold-km', email: 'km@behold.vc', campaign: 'C' },
  { id: 'ventnor-rob', email: 'rob@ventnorventures.com', campaign: 'C' },
  { id: 'initialcapital', email: 'info@initialcapital.com', campaign: 'C' },
  { id: 'bitkraft-jens', email: 'jens@bitkraft.vc', campaign: 'D' },
  { id: 'bitkraft-everett', email: 'everett.chiang@bitkraft.vc', campaign: 'D' },
  { id: 'griffin-jbaldner', email: 'jbaldner@griffingp.com', campaign: 'D' },
  { id: 'griffin-phil', email: 'phil@griffingp.com', campaign: 'D' },
  { id: 'griffin-nick', email: 'nick@griffingp.com', campaign: 'D' },
  { id: 'griffin-peter', email: 'peter@griffingp.com', campaign: 'D' },
  { id: 'playventures-harri', email: 'harri@playventures.vc', campaign: 'D' },
  { id: 'konvoy-jason', email: 'jason@konvoy.co', campaign: 'D' },
  { id: 'konvoy-josh', email: 'josh@konvoy.co', campaign: 'D' },
  { id: 'konvoy-jackson', email: 'jackson@konvoy.co', campaign: 'D' },
  { id: 'makersfund-alli', email: 'alli@makersfund.com', campaign: 'D' },
  { id: 'makersfund-info', email: 'info@makersfund.com', campaign: 'D' },
  { id: 'hiro-luke', email: 'luke@hiro.capital', campaign: 'D' },
  { id: '1upfund-kelly', email: 'kelly@1upfund.com', campaign: 'D' },
  { id: 'galaxy-sam', email: 'sam@galaxyinteractive.io', campaign: 'D' },
  { id: 'galaxy-interactive', email: 'interactive@galaxy.com', campaign: 'D' },
  { id: 'galaxy-rkim', email: 'rkim@galaxydigital.io', campaign: 'D' },
  { id: 'a16z-jgwertzman', email: 'jgwertzman@a16z.com', campaign: 'E' },
  { id: 'a16z-jlai', email: 'jlai@a16z.com', campaign: 'E' },
  { id: 'accel-sgandhi', email: 'sgandhi@accel.com', campaign: 'E' },
  { id: 'kleiner', email: 'info@kleinerperkins.com', campaign: 'E' },
  { id: 'foundersfund', email: 'info@foundersfund.com', campaign: 'E' },
  { id: 'greylock', email: 'info@greylock.com', campaign: 'E' },
  { id: 'usv', email: 'info@usv.com', campaign: 'E' },
  { id: 'sequoia-arc', email: 'arc@sequoiacap.com', campaign: 'E' },
  { id: 'firstround', email: 'info@firstround.com', campaign: 'E' },
  { id: 'nea-jkaplan', email: 'jkaplan@nea.com', campaign: 'E' },
  { id: '500', email: 'apply@500.co', campaign: 'F' },
  { id: 'launch-jacob', email: 'jacob@launch.co', campaign: 'F' },
  { id: 'svangel-ron', email: 'ron@svangel.com', campaign: 'F' },
  { id: 'signum-angela', email: 'angela@signumgrowthcapital.com', campaign: 'F' },
  { id: 'forerunner', email: 'info@forerunnerventures.com', campaign: 'F' },
  { id: 'balderton', email: 'info@balderton.com', campaign: 'F' },
  { id: 'anthos', email: 'info@anthoscapital.com', campaign: 'F' },
  { id: 'steampower', email: 'ay@steam-power.games', campaign: 'F' },
  { id: 'firstminute', email: 'info@firstminute.capital', campaign: 'F' },
  { id: 'seedcamp', email: 'info@seedcamp.com', campaign: 'F' },
  { id: 'menlo', email: 'info@menlovc.com', campaign: 'F' },
  { id: 'raine-jsalter', email: 'jsalter@raine.com', campaign: 'F' },
  { id: 'transcend-pitch', email: 'pitch@transcend.fund', campaign: 'F' },
  { id: 'upfront-kevin', email: 'kevin@upfront.com', campaign: 'F' },
  { id: 'lererhippeau', email: 'info@lererhippeau.com', campaign: 'F' },
  { id: 'weplay', email: 'play@weplayventures.com', campaign: 'F' },
  { id: 'netease', email: 'overseabd@global.netease.com', campaign: 'F' },
];

// Extract domain from email
const getDomain = (email) => {
  const parts = email.split('@');
  return parts.length > 1 ? parts[1] : email;
};

// Display-friendly domain name
const formatDomainName = (domain) => {
  // Remove common TLDs for cleaner display
  const name = domain.split('.')[0];
  return name.charAt(0).toUpperCase() + name.slice(1);
};

const EmailTracker = () => {
  const [opens, setOpens] = useState([]);
  const [domainGroups, setDomainGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({ total: 0, uniqueContacts: 0, uniqueDomains: 0 });
  const [expanded, setExpanded] = useState({});

  useEffect(() => {
    fetchOpens();
  }, []);

  const fetchOpens = async () => {
    try {
      const { data, error } = await supabase
        .from('email_opens')
        .select('*')
        .order('opened_at', { ascending: false });

      if (error) throw error;

      setOpens(data || []);

      // Create lookup of opens by contact_id
      const opensByContact = {};
      (data || []).forEach(open => {
        if (!opensByContact[open.contact_id]) {
          opensByContact[open.contact_id] = [];
        }
        opensByContact[open.contact_id].push(open);
      });

      // Group all contacts by domain
      const domains = {};
      ALL_CONTACTS.forEach(contact => {
        const domain = getDomain(contact.email);
        if (!domains[domain]) {
          domains[domain] = {
            domain,
            displayName: formatDomainName(domain),
            contacts: [],
            totalContacts: 0,
            openedCount: 0,
            totalOpens: 0,
            uniqueIPs: new Set(),
            lastOpen: null,
          };
        }

        const contactOpens = opensByContact[contact.id] || [];
        const hasOpened = contactOpens.length > 0;

        domains[domain].contacts.push({
          ...contact,
          opens: contactOpens,
          hasOpened,
          openCount: contactOpens.length,
          uniqueIPCount: new Set(contactOpens.map(o => o.ip_address)).size,
          lastOpen: contactOpens.length > 0 ? contactOpens[0].opened_at : null,
        });

        domains[domain].totalContacts++;
        if (hasOpened) {
          domains[domain].openedCount++;
          domains[domain].totalOpens += contactOpens.length;
          contactOpens.forEach(o => domains[domain].uniqueIPs.add(o.ip_address));

          const lastOpenDate = new Date(contactOpens[0].opened_at);
          if (!domains[domain].lastOpen || lastOpenDate > new Date(domains[domain].lastOpen)) {
            domains[domain].lastOpen = contactOpens[0].opened_at;
          }
        }
      });

      // Convert to array and sort
      const domainArray = Object.values(domains).map(d => ({
        ...d,
        uniqueIPCount: d.uniqueIPs.size,
        contacts: d.contacts.sort((a, b) => {
          // Opened contacts first, then by open count
          if (a.hasOpened !== b.hasOpened) return b.hasOpened - a.hasOpened;
          return b.openCount - a.openCount;
        }),
      }));

      // Sort domains: those with opens first (by open rate), then alphabetically
      domainArray.sort((a, b) => {
        if (a.openedCount > 0 && b.openedCount === 0) return -1;
        if (a.openedCount === 0 && b.openedCount > 0) return 1;
        if (a.openedCount > 0 && b.openedCount > 0) {
          // Sort by open rate
          const rateA = a.openedCount / a.totalContacts;
          const rateB = b.openedCount / b.totalContacts;
          if (rateA !== rateB) return rateB - rateA;
          // Then by total opens
          return b.totalOpens - a.totalOpens;
        }
        return a.domain.localeCompare(b.domain);
      });

      setDomainGroups(domainArray);

      // Calculate stats
      const uniqueContactsOpened = Object.keys(opensByContact).length;
      const domainsWithOpens = domainArray.filter(d => d.openedCount > 0).length;

      setStats({
        total: data?.length || 0,
        uniqueContacts: uniqueContactsOpened,
        uniqueDomains: domainsWithOpens,
      });
    } catch (err) {
      console.error('Error fetching opens:', err);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    const date = new Date(dateStr);
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  };

  const toggleExpand = (domain) => {
    setExpanded(prev => ({ ...prev, [domain]: !prev[domain] }));
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-900 text-white p-8">
        <div className="max-w-6xl mx-auto">
          <h1 className="text-2xl font-bold mb-4">Loading...</h1>
        </div>
      </div>
    );
  }

  const totalContacts = ALL_CONTACTS.length;
  const totalDomains = domainGroups.length;

  return (
    <div className="min-h-screen bg-gray-900 text-white p-8">
      <div className="max-w-6xl mx-auto">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl font-bold">Email Tracker</h1>
          <button
            onClick={fetchOpens}
            className="px-4 py-2 bg-blue-600 rounded hover:bg-blue-700"
          >
            Refresh
          </button>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-5 gap-4 mb-8">
          <div className="bg-gray-800 rounded-lg p-4">
            <div className="text-3xl font-bold text-green-400">{stats.uniqueContacts}</div>
            <div className="text-gray-400">Contacts Opened</div>
          </div>
          <div className="bg-gray-800 rounded-lg p-4">
            <div className="text-3xl font-bold text-red-400">{totalContacts - stats.uniqueContacts}</div>
            <div className="text-gray-400">Not Opened</div>
          </div>
          <div className="bg-gray-800 rounded-lg p-4">
            <div className="text-3xl font-bold text-blue-400">{stats.uniqueDomains}/{totalDomains}</div>
            <div className="text-gray-400">Companies</div>
          </div>
          <div className="bg-gray-800 rounded-lg p-4">
            <div className="text-3xl font-bold text-purple-400">{stats.total}</div>
            <div className="text-gray-400">Total Opens</div>
          </div>
          <div className="bg-gray-800 rounded-lg p-4">
            <div className="text-3xl font-bold text-yellow-400">{Math.round(stats.uniqueContacts / totalContacts * 100)}%</div>
            <div className="text-gray-400">Open Rate</div>
          </div>
        </div>

        {/* Campaign info */}
        <div className="bg-gray-800 rounded-lg p-4 mb-4">
          <span className="text-sm text-gray-400">Campaign:</span>
          <span className="ml-2 text-white font-medium">solis-seed-jan-2026</span>
          <span className="ml-4 text-sm text-gray-400">{totalContacts} contacts across {totalDomains} companies</span>
        </div>

        {/* Domain Groups */}
        <div className="space-y-2">
          {domainGroups.map((group) => {
            const isExpanded = expanded[group.domain];
            const hasAnyOpens = group.openedCount > 0;

            return (
              <div key={group.domain} className="bg-gray-800 rounded-lg overflow-hidden">
                {/* Domain Header Row */}
                <div
                  className={`flex items-center px-4 py-3 cursor-pointer hover:bg-gray-700 ${
                    hasAnyOpens ? 'border-l-4 border-green-500' : 'border-l-4 border-gray-600'
                  }`}
                  onClick={() => toggleExpand(group.domain)}
                >
                  <span className="text-gray-400 mr-3">
                    {isExpanded ? '▼' : '▶'}
                  </span>
                  <div className="flex-1">
                    <span className="font-bold text-white">{group.domain}</span>
                    <span className="ml-3 text-gray-400 text-sm">
                      {group.totalContacts} contact{group.totalContacts > 1 ? 's' : ''}
                    </span>
                  </div>
                  <div className="flex items-center gap-4">
                    {hasAnyOpens ? (
                      <>
                        <span className="px-2 py-1 rounded text-xs font-bold bg-green-900 text-green-300">
                          {group.openedCount}/{group.totalContacts} opened
                        </span>
                        {group.totalOpens > group.openedCount && (
                          <span className="px-2 py-1 rounded text-xs bg-blue-900 text-blue-300">
                            {group.totalOpens} total opens
                          </span>
                        )}
                        {group.uniqueIPCount > 1 && (
                          <span className="px-2 py-1 rounded text-xs bg-orange-900 text-orange-300">
                            {group.uniqueIPCount} IPs
                          </span>
                        )}
                        <span className="text-gray-400 text-sm">{formatDate(group.lastOpen)}</span>
                      </>
                    ) : (
                      <span className="px-2 py-1 rounded text-xs bg-gray-700 text-gray-400">
                        not opened
                      </span>
                    )}
                  </div>
                </div>

                {/* Expanded Contact Details */}
                {isExpanded && (
                  <div className="border-t border-gray-700">
                    <table className="w-full">
                      <thead className="bg-gray-750">
                        <tr>
                          <th className="px-4 py-2 text-left text-xs text-gray-400 font-medium">Status</th>
                          <th className="px-4 py-2 text-left text-xs text-gray-400 font-medium">Contact</th>
                          <th className="px-4 py-2 text-left text-xs text-gray-400 font-medium">Email</th>
                          <th className="px-4 py-2 text-left text-xs text-gray-400 font-medium">Campaign</th>
                          <th className="px-4 py-2 text-left text-xs text-gray-400 font-medium">Opens</th>
                          <th className="px-4 py-2 text-left text-xs text-gray-400 font-medium">Last Open</th>
                        </tr>
                      </thead>
                      <tbody>
                        {group.contacts.map((contact, i) => (
                          <React.Fragment key={contact.id}>
                            <tr className={`${contact.hasOpened ? 'bg-gray-800' : 'bg-gray-850'} ${
                              i !== group.contacts.length - 1 ? 'border-b border-gray-700' : ''
                            }`}>
                              <td className="px-4 py-2">
                                {contact.hasOpened ? (
                                  <span className="text-green-400">✓</span>
                                ) : (
                                  <span className="text-gray-500">✗</span>
                                )}
                              </td>
                              <td className="px-4 py-2 font-medium text-sm">
                                {contact.id}
                              </td>
                              <td className="px-4 py-2 text-gray-300 text-sm">
                                {contact.email}
                              </td>
                              <td className="px-4 py-2">
                                <span className="px-2 py-1 rounded text-xs bg-gray-700 text-gray-400">
                                  {contact.campaign}
                                </span>
                              </td>
                              <td className="px-4 py-2">
                                {contact.hasOpened ? (
                                  <div className="flex items-center gap-2">
                                    <span className={`px-2 py-1 rounded text-xs font-bold ${
                                      contact.openCount >= 3 ? 'bg-green-900 text-green-300' :
                                      contact.openCount === 2 ? 'bg-yellow-900 text-yellow-300' :
                                      'bg-gray-700 text-gray-300'
                                    }`}>
                                      {contact.openCount}x
                                    </span>
                                    {contact.uniqueIPCount > 1 && (
                                      <span className="px-2 py-1 rounded text-xs bg-orange-900 text-orange-300">
                                        {contact.uniqueIPCount} IPs
                                      </span>
                                    )}
                                  </div>
                                ) : (
                                  <span className="text-gray-500">-</span>
                                )}
                              </td>
                              <td className="px-4 py-2 text-gray-400 text-sm">
                                {formatDate(contact.lastOpen)}
                              </td>
                            </tr>
                            {/* Show individual opens if more than 1 */}
                            {contact.opens.length > 1 && contact.opens.map((open, j) => (
                              <tr key={open.id} className="bg-gray-900">
                                <td className="px-4 py-1"></td>
                                <td className="px-4 py-1 text-gray-600 text-xs pl-8">└─</td>
                                <td className="px-4 py-1 text-gray-500 text-xs" colSpan={2}>
                                  {formatDate(open.opened_at)} • {open.device} / {open.os} / {open.browser}
                                </td>
                                <td className="px-4 py-1 text-gray-600 text-xs" colSpan={2}>
                                  {open.ip_address}
                                </td>
                              </tr>
                            ))}
                          </React.Fragment>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default EmailTracker;
